<template>
  <div v-if="!hasChildren && isSearchCondition" class="filter-info" :data-filter-id="filter.id">
    <span uk-icon="icon: info; ratio: .8"></span>
  </div>
</template>

<script setup lang="ts">
  import { computed } from 'vue'

  import { Filters } from '@/services/Filters.ts'

  const props = defineProps({
    filter: {
      type: Object,
      required: true
    }
  })

  const hasChildren = computed(() => {
    return props.filter.children && props.filter.children.length > 0
  })

  /**
   * このfilterが検索条件かどうか
   * 検索条件の場合のみ、infoアイコンを出す
   * true: 検索条件
   * false: マーカー
   */
  const isSearchCondition = computed(() => {
    return !!Filters.findById(Filters.TYPE_SEARCH_CONDITIONS, props.filter.id)
  })
</script>

<style lang="scss" scoped>
  .filter-info {
    display: flex;
    align-items: center;
    justify-content: center;
  }
</style>
